// Generated from /DSL/DSL.Library/graph.g4 by ANTLR 4.13.1
// jshint ignore: start
import antlr4 from 'antlr4';


const serializedATN = [4,0,109,943,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,
2,4,7,4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,
7,12,2,13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,
19,2,20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,26,7,26,
2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,7,32,2,33,7,33,2,
34,7,34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,2,39,7,39,2,40,7,40,2,41,
7,41,2,42,7,42,2,43,7,43,2,44,7,44,2,45,7,45,2,46,7,46,2,47,7,47,2,48,7,
48,2,49,7,49,2,50,7,50,2,51,7,51,2,52,7,52,2,53,7,53,2,54,7,54,2,55,7,55,
2,56,7,56,2,57,7,57,2,58,7,58,2,59,7,59,2,60,7,60,2,61,7,61,2,62,7,62,2,
63,7,63,2,64,7,64,2,65,7,65,2,66,7,66,2,67,7,67,2,68,7,68,2,69,7,69,2,70,
7,70,2,71,7,71,2,72,7,72,2,73,7,73,2,74,7,74,2,75,7,75,2,76,7,76,2,77,7,
77,2,78,7,78,2,79,7,79,2,80,7,80,2,81,7,81,2,82,7,82,2,83,7,83,2,84,7,84,
2,85,7,85,2,86,7,86,2,87,7,87,2,88,7,88,2,89,7,89,2,90,7,90,2,91,7,91,2,
92,7,92,2,93,7,93,2,94,7,94,2,95,7,95,2,96,7,96,2,97,7,97,2,98,7,98,2,99,
7,99,2,100,7,100,2,101,7,101,2,102,7,102,2,103,7,103,2,104,7,104,2,105,7,
105,2,106,7,106,2,107,7,107,2,108,7,108,2,109,7,109,2,110,7,110,2,111,7,
111,2,112,7,112,2,113,7,113,2,114,7,114,2,115,7,115,2,116,7,116,2,117,7,
117,2,118,7,118,2,119,7,119,1,0,1,0,1,1,1,1,5,1,246,8,1,10,1,12,1,249,9,
1,1,1,1,1,1,1,1,1,5,1,255,8,1,10,1,12,1,258,9,1,1,1,1,1,3,1,262,8,1,1,2,
1,2,3,2,266,8,2,1,3,1,3,3,3,270,8,3,1,4,1,4,1,4,1,5,1,5,1,5,1,6,1,6,1,7,
1,7,1,8,1,8,1,9,1,9,1,10,1,10,1,11,1,11,1,11,1,11,1,11,1,11,1,12,1,12,1,
12,1,12,1,12,1,13,1,13,1,13,1,14,1,14,1,14,1,14,1,14,1,14,1,15,1,15,1,15,
1,15,1,15,1,15,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,17,1,
17,1,17,1,17,1,17,1,17,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,19,1,19,
1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,20,1,20,1,20,1,20,1,20,1,
20,1,20,1,20,1,20,1,20,1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,22,1,22,
1,22,1,22,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,24,1,24,1,24,1,24,1,
24,1,24,1,24,1,24,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,
1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,27,1,27,1,
27,1,27,1,27,1,27,1,27,1,27,1,28,1,28,1,28,1,29,1,29,1,29,1,29,1,29,1,30,
1,30,1,30,1,30,1,30,1,31,1,31,1,31,1,31,1,31,1,31,1,31,1,32,1,32,1,32,1,
32,1,32,1,32,1,32,1,32,1,32,1,33,1,33,1,33,1,33,1,33,1,34,1,34,1,34,1,34,
1,34,1,34,1,34,1,34,1,35,1,35,1,35,1,35,1,36,1,36,1,36,1,36,1,36,1,36,1,
36,1,36,1,36,1,37,1,37,1,37,1,37,1,37,1,37,1,37,1,38,1,38,1,38,1,38,1,38,
1,39,1,39,1,39,1,40,1,40,1,40,1,40,1,40,1,40,1,40,1,41,1,41,1,41,1,42,1,
42,1,42,1,42,1,42,1,42,1,43,1,43,1,43,1,44,1,44,1,44,1,44,1,44,1,44,1,44,
1,44,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,46,1,46,1,46,1,46,1,46,1,
47,1,47,1,47,1,47,1,48,1,48,1,48,1,49,1,49,1,49,1,50,1,50,1,50,1,50,1,50,
1,50,1,50,1,50,1,50,1,50,1,50,1,50,1,51,1,51,1,51,1,51,1,51,1,51,1,51,1,
52,1,52,1,52,1,52,1,52,1,52,1,52,1,53,1,53,1,53,1,53,1,53,1,53,1,53,1,53,
1,53,1,53,1,53,1,53,1,53,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,
55,1,55,1,55,1,55,1,55,1,55,1,55,1,56,1,56,1,56,1,56,1,56,1,57,1,57,1,57,
1,57,1,58,1,58,1,58,1,58,1,58,1,58,1,58,1,59,1,59,1,59,1,59,1,59,1,59,1,
60,1,60,1,60,1,60,1,60,1,60,1,60,1,61,1,61,1,61,1,61,1,61,1,62,1,62,1,62,
1,62,1,62,1,62,1,62,1,63,1,63,1,63,1,63,1,63,1,63,1,63,1,63,1,64,1,64,1,
64,1,64,1,64,1,64,1,64,1,64,1,64,1,64,1,64,1,64,1,65,1,65,1,65,1,65,1,65,
1,66,1,66,1,66,1,66,1,67,1,67,1,67,1,67,1,67,1,68,1,68,1,68,1,68,1,69,1,
69,1,69,1,69,1,69,1,70,1,70,1,70,1,70,1,70,1,71,1,71,1,71,1,71,1,71,1,72,
1,72,1,73,1,73,1,74,3,74,692,8,74,1,74,1,74,1,75,3,75,697,8,75,1,75,1,75,
1,76,1,76,1,76,5,76,704,8,76,10,76,12,76,707,9,76,1,76,3,76,710,8,76,1,76,
1,76,4,76,714,8,76,11,76,12,76,715,1,76,3,76,719,8,76,1,76,1,76,1,76,3,76,
724,8,76,1,77,1,77,1,77,5,77,729,8,77,10,77,12,77,732,9,77,3,77,734,8,77,
1,78,1,78,3,78,738,8,78,1,78,4,78,741,8,78,11,78,12,78,742,1,79,1,79,1,79,
1,79,1,79,1,79,1,79,1,79,1,79,3,79,754,8,79,1,80,1,80,1,80,1,80,1,80,1,80,
1,81,1,81,1,81,1,81,1,81,1,81,1,81,1,82,1,82,1,82,1,82,1,82,1,82,1,82,1,
82,1,83,1,83,1,83,1,83,1,83,1,83,1,83,1,84,1,84,1,84,1,84,1,84,1,84,1,84,
1,84,1,85,1,85,1,85,1,85,1,85,1,86,1,86,1,87,1,87,1,88,1,88,1,89,1,89,1,
90,1,90,1,91,1,91,1,92,1,92,1,93,1,93,1,94,1,94,1,95,1,95,1,96,1,96,1,97,
1,97,1,98,1,98,1,99,1,99,1,100,1,100,1,101,1,101,1,102,1,102,1,102,1,103,
1,103,1,103,1,104,1,104,1,104,1,105,1,105,1,105,1,106,1,106,1,106,1,107,
1,107,1,107,1,108,1,108,1,108,1,108,3,108,851,8,108,1,109,1,109,1,110,1,
110,1,110,1,110,1,110,3,110,860,8,110,1,111,1,111,3,111,864,8,111,1,112,
3,112,867,8,112,1,112,1,112,5,112,871,8,112,10,112,12,112,874,9,112,1,112,
3,112,877,8,112,1,112,1,112,1,112,5,112,882,8,112,10,112,12,112,885,9,112,
3,112,887,8,112,1,113,1,113,1,114,1,114,1,115,1,115,3,115,895,8,115,1,116,
1,116,1,116,1,116,5,116,901,8,116,10,116,12,116,904,9,116,1,116,1,116,1,
117,1,117,1,117,1,117,1,117,5,117,913,8,117,10,117,12,117,916,9,117,1,117,
1,117,1,117,1,117,1,117,1,118,1,118,1,118,1,118,5,118,927,8,118,10,118,12,
118,930,9,118,1,118,1,118,1,118,1,118,1,118,1,119,4,119,938,8,119,11,119,
12,119,939,1,119,1,119,2,914,928,0,120,1,0,3,1,5,0,7,0,9,0,11,0,13,2,15,
3,17,4,19,5,21,6,23,7,25,8,27,9,29,10,31,11,33,12,35,13,37,14,39,15,41,16,
43,17,45,18,47,19,49,20,51,21,53,22,55,23,57,24,59,25,61,26,63,27,65,28,
67,29,69,30,71,31,73,32,75,33,77,34,79,35,81,36,83,37,85,38,87,39,89,40,
91,41,93,42,95,43,97,44,99,45,101,46,103,47,105,48,107,49,109,50,111,51,
113,52,115,53,117,54,119,55,121,56,123,57,125,58,127,59,129,60,131,61,133,
62,135,63,137,64,139,65,141,66,143,67,145,68,147,69,149,70,151,71,153,0,
155,0,157,0,159,72,161,73,163,74,165,75,167,76,169,77,171,78,173,79,175,
80,177,81,179,82,181,83,183,84,185,85,187,86,189,87,191,88,193,89,195,90,
197,91,199,92,201,93,203,94,205,95,207,96,209,97,211,98,213,99,215,100,217,
101,219,102,221,103,223,104,225,105,227,0,229,0,231,0,233,106,235,107,237,
108,239,109,1,0,10,3,0,0,31,34,34,92,92,1,0,96,96,8,0,34,34,39,39,92,92,
98,98,102,102,110,110,114,114,116,116,1,0,48,57,1,0,49,57,2,0,69,69,101,
101,2,0,43,43,45,45,3,0,48,57,65,90,97,122,2,0,10,10,13,13,3,0,9,10,13,13,
32,32,962,0,3,1,0,0,0,0,13,1,0,0,0,0,15,1,0,0,0,0,17,1,0,0,0,0,19,1,0,0,
0,0,21,1,0,0,0,0,23,1,0,0,0,0,25,1,0,0,0,0,27,1,0,0,0,0,29,1,0,0,0,0,31,
1,0,0,0,0,33,1,0,0,0,0,35,1,0,0,0,0,37,1,0,0,0,0,39,1,0,0,0,0,41,1,0,0,0,
0,43,1,0,0,0,0,45,1,0,0,0,0,47,1,0,0,0,0,49,1,0,0,0,0,51,1,0,0,0,0,53,1,
0,0,0,0,55,1,0,0,0,0,57,1,0,0,0,0,59,1,0,0,0,0,61,1,0,0,0,0,63,1,0,0,0,0,
65,1,0,0,0,0,67,1,0,0,0,0,69,1,0,0,0,0,71,1,0,0,0,0,73,1,0,0,0,0,75,1,0,
0,0,0,77,1,0,0,0,0,79,1,0,0,0,0,81,1,0,0,0,0,83,1,0,0,0,0,85,1,0,0,0,0,87,
1,0,0,0,0,89,1,0,0,0,0,91,1,0,0,0,0,93,1,0,0,0,0,95,1,0,0,0,0,97,1,0,0,0,
0,99,1,0,0,0,0,101,1,0,0,0,0,103,1,0,0,0,0,105,1,0,0,0,0,107,1,0,0,0,0,109,
1,0,0,0,0,111,1,0,0,0,0,113,1,0,0,0,0,115,1,0,0,0,0,117,1,0,0,0,0,119,1,
0,0,0,0,121,1,0,0,0,0,123,1,0,0,0,0,125,1,0,0,0,0,127,1,0,0,0,0,129,1,0,
0,0,0,131,1,0,0,0,0,133,1,0,0,0,0,135,1,0,0,0,0,137,1,0,0,0,0,139,1,0,0,
0,0,141,1,0,0,0,0,143,1,0,0,0,0,145,1,0,0,0,0,147,1,0,0,0,0,149,1,0,0,0,
0,151,1,0,0,0,0,159,1,0,0,0,0,161,1,0,0,0,0,163,1,0,0,0,0,165,1,0,0,0,0,
167,1,0,0,0,0,169,1,0,0,0,0,171,1,0,0,0,0,173,1,0,0,0,0,175,1,0,0,0,0,177,
1,0,0,0,0,179,1,0,0,0,0,181,1,0,0,0,0,183,1,0,0,0,0,185,1,0,0,0,0,187,1,
0,0,0,0,189,1,0,0,0,0,191,1,0,0,0,0,193,1,0,0,0,0,195,1,0,0,0,0,197,1,0,
0,0,0,199,1,0,0,0,0,201,1,0,0,0,0,203,1,0,0,0,0,205,1,0,0,0,0,207,1,0,0,
0,0,209,1,0,0,0,0,211,1,0,0,0,0,213,1,0,0,0,0,215,1,0,0,0,0,217,1,0,0,0,
0,219,1,0,0,0,0,221,1,0,0,0,0,223,1,0,0,0,0,225,1,0,0,0,0,233,1,0,0,0,0,
235,1,0,0,0,0,237,1,0,0,0,0,239,1,0,0,0,1,241,1,0,0,0,3,261,1,0,0,0,5,265,
1,0,0,0,7,269,1,0,0,0,9,271,1,0,0,0,11,274,1,0,0,0,13,277,1,0,0,0,15,279,
1,0,0,0,17,281,1,0,0,0,19,283,1,0,0,0,21,285,1,0,0,0,23,287,1,0,0,0,25,293,
1,0,0,0,27,298,1,0,0,0,29,301,1,0,0,0,31,307,1,0,0,0,33,313,1,0,0,0,35,323,
1,0,0,0,37,329,1,0,0,0,39,337,1,0,0,0,41,348,1,0,0,0,43,358,1,0,0,0,45,366,
1,0,0,0,47,370,1,0,0,0,49,378,1,0,0,0,51,386,1,0,0,0,53,397,1,0,0,0,55,409,
1,0,0,0,57,417,1,0,0,0,59,420,1,0,0,0,61,425,1,0,0,0,63,430,1,0,0,0,65,437,
1,0,0,0,67,446,1,0,0,0,69,451,1,0,0,0,71,459,1,0,0,0,73,463,1,0,0,0,75,472,
1,0,0,0,77,479,1,0,0,0,79,484,1,0,0,0,81,487,1,0,0,0,83,494,1,0,0,0,85,497,
1,0,0,0,87,503,1,0,0,0,89,506,1,0,0,0,91,514,1,0,0,0,93,522,1,0,0,0,95,527,
1,0,0,0,97,531,1,0,0,0,99,534,1,0,0,0,101,537,1,0,0,0,103,549,1,0,0,0,105,
556,1,0,0,0,107,563,1,0,0,0,109,576,1,0,0,0,111,585,1,0,0,0,113,592,1,0,
0,0,115,597,1,0,0,0,117,601,1,0,0,0,119,608,1,0,0,0,121,614,1,0,0,0,123,
621,1,0,0,0,125,626,1,0,0,0,127,633,1,0,0,0,129,641,1,0,0,0,131,653,1,0,
0,0,133,658,1,0,0,0,135,662,1,0,0,0,137,667,1,0,0,0,139,671,1,0,0,0,141,
676,1,0,0,0,143,681,1,0,0,0,145,686,1,0,0,0,147,688,1,0,0,0,149,691,1,0,
0,0,151,696,1,0,0,0,153,723,1,0,0,0,155,733,1,0,0,0,157,735,1,0,0,0,159,
753,1,0,0,0,161,755,1,0,0,0,163,761,1,0,0,0,165,768,1,0,0,0,167,776,1,0,
0,0,169,783,1,0,0,0,171,791,1,0,0,0,173,796,1,0,0,0,175,798,1,0,0,0,177,
800,1,0,0,0,179,802,1,0,0,0,181,804,1,0,0,0,183,806,1,0,0,0,185,808,1,0,
0,0,187,810,1,0,0,0,189,812,1,0,0,0,191,814,1,0,0,0,193,816,1,0,0,0,195,
818,1,0,0,0,197,820,1,0,0,0,199,822,1,0,0,0,201,824,1,0,0,0,203,826,1,0,
0,0,205,828,1,0,0,0,207,831,1,0,0,0,209,834,1,0,0,0,211,837,1,0,0,0,213,
840,1,0,0,0,215,843,1,0,0,0,217,850,1,0,0,0,219,852,1,0,0,0,221,859,1,0,
0,0,223,863,1,0,0,0,225,886,1,0,0,0,227,888,1,0,0,0,229,890,1,0,0,0,231,
894,1,0,0,0,233,896,1,0,0,0,235,907,1,0,0,0,237,922,1,0,0,0,239,937,1,0,
0,0,241,242,8,0,0,0,242,2,1,0,0,0,243,247,3,191,95,0,244,246,3,7,3,0,245,
244,1,0,0,0,246,249,1,0,0,0,247,245,1,0,0,0,247,248,1,0,0,0,248,250,1,0,
0,0,249,247,1,0,0,0,250,251,3,191,95,0,251,262,1,0,0,0,252,256,3,189,94,
0,253,255,3,5,2,0,254,253,1,0,0,0,255,258,1,0,0,0,256,254,1,0,0,0,256,257,
1,0,0,0,257,259,1,0,0,0,258,256,1,0,0,0,259,260,3,189,94,0,260,262,1,0,0,
0,261,243,1,0,0,0,261,252,1,0,0,0,262,4,1,0,0,0,263,266,3,1,0,0,264,266,
3,11,5,0,265,263,1,0,0,0,265,264,1,0,0,0,266,6,1,0,0,0,267,270,8,1,0,0,268,
270,3,9,4,0,269,267,1,0,0,0,269,268,1,0,0,0,270,8,1,0,0,0,271,272,5,92,0,
0,272,273,7,1,0,0,273,10,1,0,0,0,274,275,5,92,0,0,275,276,7,2,0,0,276,12,
1,0,0,0,277,278,5,43,0,0,278,14,1,0,0,0,279,280,5,45,0,0,280,16,1,0,0,0,
281,282,5,42,0,0,282,18,1,0,0,0,283,284,5,47,0,0,284,20,1,0,0,0,285,286,
5,37,0,0,286,22,1,0,0,0,287,288,5,97,0,0,288,289,5,112,0,0,289,290,5,112,
0,0,290,291,5,108,0,0,291,292,5,121,0,0,292,24,1,0,0,0,293,294,5,119,0,0,
294,295,5,105,0,0,295,296,5,116,0,0,296,297,5,104,0,0,297,26,1,0,0,0,298,
299,5,97,0,0,299,300,5,115,0,0,300,28,1,0,0,0,301,302,5,97,0,0,302,303,5,
115,0,0,303,304,5,121,0,0,304,305,5,110,0,0,305,306,5,99,0,0,306,30,1,0,
0,0,307,308,5,98,0,0,308,309,5,108,0,0,309,310,5,111,0,0,310,311,5,99,0,
0,311,312,5,107,0,0,312,32,1,0,0,0,313,314,5,98,0,0,314,315,5,108,0,0,315,
316,5,111,0,0,316,317,5,99,0,0,317,318,5,107,0,0,318,319,5,99,0,0,319,320,
5,97,0,0,320,321,5,108,0,0,321,322,5,108,0,0,322,34,1,0,0,0,323,324,5,99,
0,0,324,325,5,97,0,0,325,326,5,116,0,0,326,327,5,99,0,0,327,328,5,104,0,
0,328,36,1,0,0,0,329,330,5,99,0,0,330,331,5,111,0,0,331,332,5,109,0,0,332,
333,5,109,0,0,333,334,5,101,0,0,334,335,5,110,0,0,335,336,5,116,0,0,336,
38,1,0,0,0,337,338,5,99,0,0,338,339,5,111,0,0,339,340,5,110,0,0,340,341,
5,100,0,0,341,342,5,105,0,0,342,343,5,116,0,0,343,344,5,105,0,0,344,345,
5,111,0,0,345,346,5,110,0,0,346,347,5,115,0,0,347,40,1,0,0,0,348,349,5,99,
0,0,349,350,5,111,0,0,350,351,5,110,0,0,351,352,5,102,0,0,352,353,5,105,
0,0,353,354,5,100,0,0,354,355,5,101,0,0,355,356,5,110,0,0,356,357,5,116,
0,0,357,42,1,0,0,0,358,359,5,99,0,0,359,360,5,111,0,0,360,361,5,110,0,0,
361,362,5,116,0,0,362,363,5,101,0,0,363,364,5,120,0,0,364,365,5,116,0,0,
365,44,1,0,0,0,366,367,5,99,0,0,367,368,5,111,0,0,368,369,5,119,0,0,369,
46,1,0,0,0,370,371,5,100,0,0,371,372,5,101,0,0,372,373,5,102,0,0,373,374,
5,97,0,0,374,375,5,117,0,0,375,376,5,108,0,0,376,377,5,116,0,0,377,48,1,
0,0,0,378,379,5,100,0,0,379,380,5,101,0,0,380,381,5,102,0,0,381,382,5,105,
0,0,382,383,5,110,0,0,383,384,5,101,0,0,384,385,5,100,0,0,385,50,1,0,0,0,
386,387,5,100,0,0,387,388,5,105,0,0,388,389,5,103,0,0,389,390,5,114,0,0,
390,391,5,101,0,0,391,392,5,115,0,0,392,393,5,115,0,0,393,394,5,105,0,0,
394,395,5,111,0,0,395,396,5,110,0,0,396,52,1,0,0,0,397,398,5,100,0,0,398,
399,5,105,0,0,399,400,5,103,0,0,400,401,5,114,0,0,401,402,5,101,0,0,402,
403,5,115,0,0,403,404,5,115,0,0,404,405,5,105,0,0,405,406,5,111,0,0,406,
407,5,110,0,0,407,408,5,115,0,0,408,54,1,0,0,0,409,410,5,100,0,0,410,411,
5,105,0,0,411,412,5,115,0,0,412,413,5,97,0,0,413,414,5,98,0,0,414,415,5,
108,0,0,415,416,5,101,0,0,416,56,1,0,0,0,417,418,5,100,0,0,418,419,5,111,
0,0,419,58,1,0,0,0,420,421,5,100,0,0,421,422,5,111,0,0,422,423,5,110,0,0,
423,424,5,101,0,0,424,60,1,0,0,0,425,426,5,101,0,0,426,427,5,108,0,0,427,
428,5,115,0,0,428,429,5,101,0,0,429,62,1,0,0,0,430,431,5,101,0,0,431,432,
5,110,0,0,432,433,5,97,0,0,433,434,5,98,0,0,434,435,5,108,0,0,435,436,5,
101,0,0,436,64,1,0,0,0,437,438,5,101,0,0,438,439,5,120,0,0,439,440,5,116,
0,0,440,441,5,101,0,0,441,442,5,114,0,0,442,443,5,110,0,0,443,444,5,97,0,
0,444,445,5,108,0,0,445,66,1,0,0,0,446,447,5,101,0,0,447,448,5,120,0,0,448,
449,5,105,0,0,449,450,5,116,0,0,450,68,1,0,0,0,451,452,5,102,0,0,452,453,
5,105,0,0,453,454,5,110,0,0,454,455,5,97,0,0,455,456,5,108,0,0,456,457,5,
108,0,0,457,458,5,121,0,0,458,70,1,0,0,0,459,460,5,102,0,0,460,461,5,111,
0,0,461,462,5,114,0,0,462,72,1,0,0,0,463,464,5,102,0,0,464,465,5,117,0,0,
465,466,5,110,0,0,466,467,5,99,0,0,467,468,5,116,0,0,468,469,5,105,0,0,469,
470,5,111,0,0,470,471,5,110,0,0,471,74,1,0,0,0,472,473,5,103,0,0,473,474,
5,108,0,0,474,475,5,111,0,0,475,476,5,98,0,0,476,477,5,97,0,0,477,478,5,
108,0,0,478,76,1,0,0,0,479,480,5,103,0,0,480,481,5,111,0,0,481,482,5,116,
0,0,482,483,5,111,0,0,483,78,1,0,0,0,484,485,5,105,0,0,485,486,5,102,0,0,
486,80,1,0,0,0,487,488,5,105,0,0,488,489,5,109,0,0,489,490,5,112,0,0,490,
491,5,111,0,0,491,492,5,114,0,0,492,493,5,116,0,0,493,82,1,0,0,0,494,495,
5,105,0,0,495,496,5,110,0,0,496,84,1,0,0,0,497,498,5,105,0,0,498,499,5,110,
0,0,499,500,5,112,0,0,500,501,5,117,0,0,501,502,5,116,0,0,502,86,1,0,0,0,
503,504,5,105,0,0,504,505,5,115,0,0,505,88,1,0,0,0,506,507,5,108,0,0,507,
508,5,105,0,0,508,509,5,98,0,0,509,510,5,114,0,0,510,511,5,97,0,0,511,512,
5,114,0,0,512,513,5,121,0,0,513,90,1,0,0,0,514,515,5,108,0,0,515,516,5,111,
0,0,516,517,5,103,0,0,517,518,5,101,0,0,518,519,5,120,0,0,519,520,5,112,
0,0,520,521,5,114,0,0,521,92,1,0,0,0,522,523,5,110,0,0,523,524,5,111,0,0,
524,525,5,100,0,0,525,526,5,101,0,0,526,94,1,0,0,0,527,528,5,110,0,0,528,
529,5,111,0,0,529,530,5,116,0,0,530,96,1,0,0,0,531,532,5,111,0,0,532,533,
5,102,0,0,533,98,1,0,0,0,534,535,5,111,0,0,535,536,5,110,0,0,536,100,1,0,
0,0,537,538,5,111,0,0,538,539,5,110,0,0,539,540,5,100,0,0,540,541,5,105,
0,0,541,542,5,103,0,0,542,543,5,114,0,0,543,544,5,101,0,0,544,545,5,116,
0,0,545,546,5,117,0,0,546,547,5,114,0,0,547,548,5,110,0,0,548,102,1,0,0,
0,549,550,5,111,0,0,550,551,5,110,0,0,551,552,5,101,0,0,552,553,5,120,0,
0,553,554,5,105,0,0,554,555,5,116,0,0,555,104,1,0,0,0,556,557,5,111,0,0,
557,558,5,117,0,0,558,559,5,116,0,0,559,560,5,112,0,0,560,561,5,117,0,0,
561,562,5,116,0,0,562,106,1,0,0,0,563,564,5,112,0,0,564,565,5,114,0,0,565,
566,5,101,0,0,566,567,5,112,0,0,567,568,5,114,0,0,568,569,5,111,0,0,569,
570,5,99,0,0,570,571,5,101,0,0,571,572,5,115,0,0,572,573,5,115,0,0,573,574,
5,111,0,0,574,575,5,114,0,0,575,108,1,0,0,0,576,577,5,112,0,0,577,578,5,
114,0,0,578,579,5,105,0,0,579,580,5,111,0,0,580,581,5,114,0,0,581,582,5,
105,0,0,582,583,5,116,0,0,583,584,5,121,0,0,584,110,1,0,0,0,585,586,5,114,
0,0,586,587,5,101,0,0,587,588,5,116,0,0,588,589,5,117,0,0,589,590,5,114,
0,0,590,591,5,110,0,0,591,112,1,0,0,0,592,593,5,115,0,0,593,594,5,97,0,0,
594,595,5,118,0,0,595,596,5,101,0,0,596,114,1,0,0,0,597,598,5,115,0,0,598,
599,5,101,0,0,599,600,5,116,0,0,600,116,1,0,0,0,601,602,5,115,0,0,602,603,
5,104,0,0,603,604,5,97,0,0,604,605,5,114,0,0,605,606,5,101,0,0,606,607,5,
100,0,0,607,118,1,0,0,0,608,609,5,115,0,0,609,610,5,116,0,0,610,611,5,97,
0,0,611,612,5,114,0,0,612,613,5,116,0,0,613,120,1,0,0,0,614,615,5,115,0,
0,615,616,5,116,0,0,616,617,5,97,0,0,617,618,5,116,0,0,618,619,5,105,0,0,
619,620,5,99,0,0,620,122,1,0,0,0,621,622,5,115,0,0,622,623,5,121,0,0,623,
624,5,110,0,0,624,625,5,99,0,0,625,124,1,0,0,0,626,627,5,115,0,0,627,628,
5,121,0,0,628,629,5,115,0,0,629,630,5,116,0,0,630,631,5,101,0,0,631,632,
5,109,0,0,632,126,1,0,0,0,633,634,5,116,0,0,634,635,5,105,0,0,635,636,5,
109,0,0,636,637,5,101,0,0,637,638,5,111,0,0,638,639,5,117,0,0,639,640,5,
116,0,0,640,128,1,0,0,0,641,642,5,116,0,0,642,643,5,114,0,0,643,644,5,97,
0,0,644,645,5,110,0,0,645,646,5,115,0,0,646,647,5,105,0,0,647,648,5,116,
0,0,648,649,5,105,0,0,649,650,5,111,0,0,650,651,5,110,0,0,651,652,5,115,
0,0,652,130,1,0,0,0,653,654,5,116,0,0,654,655,5,97,0,0,655,656,5,103,0,0,
656,657,5,115,0,0,657,132,1,0,0,0,658,659,5,116,0,0,659,660,5,114,0,0,660,
661,5,121,0,0,661,134,1,0,0,0,662,663,5,116,0,0,663,664,5,121,0,0,664,665,
5,112,0,0,665,666,5,101,0,0,666,136,1,0,0,0,667,668,5,118,0,0,668,669,5,
97,0,0,669,670,5,114,0,0,670,138,1,0,0,0,671,672,5,119,0,0,672,673,5,97,
0,0,673,674,5,105,0,0,674,675,5,116,0,0,675,140,1,0,0,0,676,677,5,119,0,
0,677,678,5,104,0,0,678,679,5,101,0,0,679,680,5,110,0,0,680,142,1,0,0,0,
681,682,5,102,0,0,682,683,5,105,0,0,683,684,5,108,0,0,684,685,5,108,0,0,
685,144,1,0,0,0,686,687,5,35,0,0,687,146,1,0,0,0,688,689,5,36,0,0,689,148,
1,0,0,0,690,692,3,15,7,0,691,690,1,0,0,0,691,692,1,0,0,0,692,693,1,0,0,0,
693,694,3,153,76,0,694,150,1,0,0,0,695,697,3,15,7,0,696,695,1,0,0,0,696,
697,1,0,0,0,697,698,1,0,0,0,698,699,3,155,77,0,699,152,1,0,0,0,700,701,3,
155,77,0,701,705,3,201,100,0,702,704,7,3,0,0,703,702,1,0,0,0,704,707,1,0,
0,0,705,703,1,0,0,0,705,706,1,0,0,0,706,709,1,0,0,0,707,705,1,0,0,0,708,
710,3,157,78,0,709,708,1,0,0,0,709,710,1,0,0,0,710,724,1,0,0,0,711,713,3,
201,100,0,712,714,7,3,0,0,713,712,1,0,0,0,714,715,1,0,0,0,715,713,1,0,0,
0,715,716,1,0,0,0,716,718,1,0,0,0,717,719,3,157,78,0,718,717,1,0,0,0,718,
719,1,0,0,0,719,724,1,0,0,0,720,721,3,155,77,0,721,722,3,157,78,0,722,724,
1,0,0,0,723,700,1,0,0,0,723,711,1,0,0,0,723,720,1,0,0,0,724,154,1,0,0,0,
725,734,5,48,0,0,726,730,7,4,0,0,727,729,7,3,0,0,728,727,1,0,0,0,729,732,
1,0,0,0,730,728,1,0,0,0,730,731,1,0,0,0,731,734,1,0,0,0,732,730,1,0,0,0,
733,725,1,0,0,0,733,726,1,0,0,0,734,156,1,0,0,0,735,737,7,5,0,0,736,738,
7,6,0,0,737,736,1,0,0,0,737,738,1,0,0,0,738,740,1,0,0,0,739,741,7,3,0,0,
740,739,1,0,0,0,741,742,1,0,0,0,742,740,1,0,0,0,742,743,1,0,0,0,743,158,
1,0,0,0,744,745,5,116,0,0,745,746,5,114,0,0,746,747,5,117,0,0,747,754,5,
101,0,0,748,749,5,102,0,0,749,750,5,97,0,0,750,751,5,108,0,0,751,752,5,115,
0,0,752,754,5,101,0,0,753,744,1,0,0,0,753,748,1,0,0,0,754,160,1,0,0,0,755,
756,5,101,0,0,756,757,5,109,0,0,757,758,5,112,0,0,758,759,5,116,0,0,759,
760,5,121,0,0,760,162,1,0,0,0,761,762,5,110,0,0,762,763,5,117,0,0,763,764,
5,109,0,0,764,765,5,98,0,0,765,766,5,101,0,0,766,767,5,114,0,0,767,164,1,
0,0,0,768,769,5,98,0,0,769,770,5,111,0,0,770,771,5,111,0,0,771,772,5,108,
0,0,772,773,5,101,0,0,773,774,5,97,0,0,774,775,5,110,0,0,775,166,1,0,0,0,
776,777,5,115,0,0,777,778,5,116,0,0,778,779,5,114,0,0,779,780,5,105,0,0,
780,781,5,110,0,0,781,782,5,103,0,0,782,168,1,0,0,0,783,784,5,117,0,0,784,
785,5,110,0,0,785,786,5,107,0,0,786,787,5,110,0,0,787,788,5,111,0,0,788,
789,5,119,0,0,789,790,5,110,0,0,790,170,1,0,0,0,791,792,5,110,0,0,792,793,
5,117,0,0,793,794,5,108,0,0,794,795,5,108,0,0,795,172,1,0,0,0,796,797,5,
93,0,0,797,174,1,0,0,0,798,799,5,91,0,0,799,176,1,0,0,0,800,801,5,62,0,0,
801,178,1,0,0,0,802,803,5,60,0,0,803,180,1,0,0,0,804,805,5,41,0,0,805,182,
1,0,0,0,806,807,5,40,0,0,807,184,1,0,0,0,808,809,5,125,0,0,809,186,1,0,0,
0,810,811,5,123,0,0,811,188,1,0,0,0,812,813,5,34,0,0,813,190,1,0,0,0,814,
815,5,96,0,0,815,192,1,0,0,0,816,817,5,58,0,0,817,194,1,0,0,0,818,819,5,
59,0,0,819,196,1,0,0,0,820,821,5,44,0,0,821,198,1,0,0,0,822,823,5,63,0,0,
823,200,1,0,0,0,824,825,5,46,0,0,825,202,1,0,0,0,826,827,5,61,0,0,827,204,
1,0,0,0,828,829,5,43,0,0,829,830,5,61,0,0,830,206,1,0,0,0,831,832,5,45,0,
0,832,833,5,61,0,0,833,208,1,0,0,0,834,835,5,61,0,0,835,836,5,61,0,0,836,
210,1,0,0,0,837,838,5,33,0,0,838,839,5,61,0,0,839,212,1,0,0,0,840,841,5,
62,0,0,841,842,5,61,0,0,842,214,1,0,0,0,843,844,5,60,0,0,844,845,5,61,0,
0,845,216,1,0,0,0,846,847,5,124,0,0,847,851,5,124,0,0,848,849,5,111,0,0,
849,851,5,114,0,0,850,846,1,0,0,0,850,848,1,0,0,0,851,218,1,0,0,0,852,853,
5,124,0,0,853,220,1,0,0,0,854,855,5,38,0,0,855,860,5,38,0,0,856,857,5,97,
0,0,857,858,5,110,0,0,858,860,5,100,0,0,859,854,1,0,0,0,859,856,1,0,0,0,
860,222,1,0,0,0,861,864,5,33,0,0,862,864,3,95,47,0,863,861,1,0,0,0,863,862,
1,0,0,0,864,224,1,0,0,0,865,867,5,64,0,0,866,865,1,0,0,0,866,867,1,0,0,0,
867,868,1,0,0,0,868,872,3,229,114,0,869,871,3,231,115,0,870,869,1,0,0,0,
871,874,1,0,0,0,872,870,1,0,0,0,872,873,1,0,0,0,873,887,1,0,0,0,874,872,
1,0,0,0,875,877,5,64,0,0,876,875,1,0,0,0,876,877,1,0,0,0,877,878,1,0,0,0,
878,879,3,227,113,0,879,883,3,229,114,0,880,882,3,231,115,0,881,880,1,0,
0,0,882,885,1,0,0,0,883,881,1,0,0,0,883,884,1,0,0,0,884,887,1,0,0,0,885,
883,1,0,0,0,886,866,1,0,0,0,886,876,1,0,0,0,887,226,1,0,0,0,888,889,5,95,
0,0,889,228,1,0,0,0,890,891,7,7,0,0,891,230,1,0,0,0,892,895,3,229,114,0,
893,895,3,227,113,0,894,892,1,0,0,0,894,893,1,0,0,0,895,232,1,0,0,0,896,
897,5,47,0,0,897,898,5,47,0,0,898,902,1,0,0,0,899,901,8,8,0,0,900,899,1,
0,0,0,901,904,1,0,0,0,902,900,1,0,0,0,902,903,1,0,0,0,903,905,1,0,0,0,904,
902,1,0,0,0,905,906,6,116,0,0,906,234,1,0,0,0,907,908,5,47,0,0,908,909,5,
42,0,0,909,910,5,42,0,0,910,914,1,0,0,0,911,913,9,0,0,0,912,911,1,0,0,0,
913,916,1,0,0,0,914,915,1,0,0,0,914,912,1,0,0,0,915,917,1,0,0,0,916,914,
1,0,0,0,917,918,5,42,0,0,918,919,5,47,0,0,919,920,1,0,0,0,920,921,6,117,
1,0,921,236,1,0,0,0,922,923,5,47,0,0,923,924,5,42,0,0,924,928,1,0,0,0,925,
927,9,0,0,0,926,925,1,0,0,0,927,930,1,0,0,0,928,929,1,0,0,0,928,926,1,0,
0,0,929,931,1,0,0,0,930,928,1,0,0,0,931,932,5,42,0,0,932,933,5,47,0,0,933,
934,1,0,0,0,934,935,6,118,0,0,935,238,1,0,0,0,936,938,7,9,0,0,937,936,1,
0,0,0,938,939,1,0,0,0,939,937,1,0,0,0,939,940,1,0,0,0,940,941,1,0,0,0,941,
942,6,119,2,0,942,240,1,0,0,0,31,0,247,256,261,265,269,691,696,705,709,715,
718,723,730,733,737,742,753,850,859,863,866,872,876,883,886,894,902,914,
928,939,3,0,1,0,0,2,0,6,0,0];


const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map( (ds, index) => new antlr4.dfa.DFA(ds, index) );

export default class graphLexer extends antlr4.Lexer {

    static grammarFileName = "graph.g4";
    static channelNames = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];
	static modeNames = [ "DEFAULT_MODE" ];
	static literalNames = [ null, null, "'+'", "'-'", "'*'", "'/'", "'%'", 
                         "'apply'", "'with'", "'as'", "'async'", "'block'", 
                         "'blockcall'", "'catch'", "'comment'", "'conditions'", 
                         "'confident'", "'context'", "'cow'", "'default'", 
                         "'defined'", "'digression'", "'digressions'", "'disable'", 
                         "'do'", "'done'", "'else'", "'enable'", "'external'", 
                         "'exit'", "'finally'", "'for'", "'function'", "'global'", 
                         "'goto'", "'if'", "'import'", "'in'", "'input'", 
                         "'is'", "'library'", "'logexpr'", "'node'", "'not'", 
                         "'of'", "'on'", "'ondigreturn'", "'onexit'", "'output'", 
                         "'preprocessor'", "'priority'", "'return'", "'save'", 
                         "'set'", "'shared'", "'start'", "'static'", "'sync'", 
                         "'system'", "'timeout'", "'transitions'", "'tags'", 
                         "'try'", "'type'", "'var'", "'wait'", "'when'", 
                         "'fill'", "'#'", "'$'", null, null, null, "'empty'", 
                         "'number'", "'boolean'", "'string'", "'unknown'", 
                         "'null'", "']'", "'['", "'>'", "'<'", "')'", "'('", 
                         "'}'", "'{'", "'\"'", "'`'", "':'", "';'", "','", 
                         "'?'", "'.'", "'='", "'+='", "'-='", "'=='", "'!='", 
                         "'>='", "'<='", null, "'|'" ];
	static symbolicNames = [ null, "StringLiteral", "PLUS", "MINUS", "STAR", 
                          "SLASH", "PERCENT", "APPLY", "WITH", "AS", "ASYNC", 
                          "BLOCK", "BLOCKCALL", "CATCH", "COMMENT", "CONDITIONS", 
                          "CONFIDENT", "CONTEXT", "COW", "DEFAULT", "DEFINED", 
                          "DIGRESSION", "DIGRESSIONS", "DISABLE", "DO", 
                          "DONE", "ELSE", "ENABLE", "EXTERNAL", "EXIT", 
                          "FINALLY", "FOR", "FUNCTION", "GLOBAL", "GOTO", 
                          "IF", "IMPORT", "IN", "INPUT", "IS", "LIBRARY", 
                          "LOGEXPR", "NODE", "NOT", "OF", "ON", "ONDIGRETURN", 
                          "ONEXIT", "OUTPUT", "PREPROCESSOR", "PRIORITY", 
                          "RETURN", "SAVE", "SET", "SHARED", "START", "STATIC", 
                          "SYNC", "SYSTEM", "TIMEOUT", "TRANSITIONS", "TAGS", 
                          "TRY", "TYPE", "VAR", "WAIT", "WHEN", "FILL", 
                          "BuiltinMark", "ContextMark", "DecimalLiteral", 
                          "DecimalIntegerLiteral", "BooleanLiteral", "Empty", 
                          "Number", "Boolean", "String", "Unknown", "NULL", 
                          "RBRACKET", "LBRACKET", "RANGLE", "LANGLE", "RPAREN", 
                          "LPAREN", "RCURL", "LCURL", "QUOTE", "BACKTRICK", 
                          "COLON", "SEMICOLON", "COMMA", "QMARK", "PERIOD", 
                          "EQUALSIGN", "AddOp", "RemoveOp", "EqualOp", "NotEqualOp", 
                          "GreaterEqualOp", "LessEqualOp", "OrOp", "TypeOr", 
                          "AndOp", "NotOperator", "ID", "LineComment", "DocsComment", 
                          "BlockComment", "Whitespace" ];
	static ruleNames = [ "SafeCodePoint", "StringLiteral", "StringCharacter", 
                      "MultilineStringCharacter", "MultilineEscapeSequence", 
                      "EscapeSequence", "PLUS", "MINUS", "STAR", "SLASH", 
                      "PERCENT", "APPLY", "WITH", "AS", "ASYNC", "BLOCK", 
                      "BLOCKCALL", "CATCH", "COMMENT", "CONDITIONS", "CONFIDENT", 
                      "CONTEXT", "COW", "DEFAULT", "DEFINED", "DIGRESSION", 
                      "DIGRESSIONS", "DISABLE", "DO", "DONE", "ELSE", "ENABLE", 
                      "EXTERNAL", "EXIT", "FINALLY", "FOR", "FUNCTION", 
                      "GLOBAL", "GOTO", "IF", "IMPORT", "IN", "INPUT", "IS", 
                      "LIBRARY", "LOGEXPR", "NODE", "NOT", "OF", "ON", "ONDIGRETURN", 
                      "ONEXIT", "OUTPUT", "PREPROCESSOR", "PRIORITY", "RETURN", 
                      "SAVE", "SET", "SHARED", "START", "STATIC", "SYNC", 
                      "SYSTEM", "TIMEOUT", "TRANSITIONS", "TAGS", "TRY", 
                      "TYPE", "VAR", "WAIT", "WHEN", "FILL", "BuiltinMark", 
                      "ContextMark", "DecimalLiteral", "DecimalIntegerLiteral", 
                      "DecimalLiteralAbsoluteValue", "DecimalIntegerLiteralAbsoluteValue", 
                      "ExponentPart", "BooleanLiteral", "Empty", "Number", 
                      "Boolean", "String", "Unknown", "NULL", "RBRACKET", 
                      "LBRACKET", "RANGLE", "LANGLE", "RPAREN", "LPAREN", 
                      "RCURL", "LCURL", "QUOTE", "BACKTRICK", "COLON", "SEMICOLON", 
                      "COMMA", "QMARK", "PERIOD", "EQUALSIGN", "AddOp", 
                      "RemoveOp", "EqualOp", "NotEqualOp", "GreaterEqualOp", 
                      "LessEqualOp", "OrOp", "TypeOr", "AndOp", "NotOperator", 
                      "ID", "Underscore", "NonUnderscoreIdSymbol", "AnyIdSymbol", 
                      "LineComment", "DocsComment", "BlockComment", "Whitespace" ];

    constructor(input) {
        super(input)
        this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.atn.PredictionContextCache());
    }
}

graphLexer.EOF = antlr4.Token.EOF;
graphLexer.StringLiteral = 1;
graphLexer.PLUS = 2;
graphLexer.MINUS = 3;
graphLexer.STAR = 4;
graphLexer.SLASH = 5;
graphLexer.PERCENT = 6;
graphLexer.APPLY = 7;
graphLexer.WITH = 8;
graphLexer.AS = 9;
graphLexer.ASYNC = 10;
graphLexer.BLOCK = 11;
graphLexer.BLOCKCALL = 12;
graphLexer.CATCH = 13;
graphLexer.COMMENT = 14;
graphLexer.CONDITIONS = 15;
graphLexer.CONFIDENT = 16;
graphLexer.CONTEXT = 17;
graphLexer.COW = 18;
graphLexer.DEFAULT = 19;
graphLexer.DEFINED = 20;
graphLexer.DIGRESSION = 21;
graphLexer.DIGRESSIONS = 22;
graphLexer.DISABLE = 23;
graphLexer.DO = 24;
graphLexer.DONE = 25;
graphLexer.ELSE = 26;
graphLexer.ENABLE = 27;
graphLexer.EXTERNAL = 28;
graphLexer.EXIT = 29;
graphLexer.FINALLY = 30;
graphLexer.FOR = 31;
graphLexer.FUNCTION = 32;
graphLexer.GLOBAL = 33;
graphLexer.GOTO = 34;
graphLexer.IF = 35;
graphLexer.IMPORT = 36;
graphLexer.IN = 37;
graphLexer.INPUT = 38;
graphLexer.IS = 39;
graphLexer.LIBRARY = 40;
graphLexer.LOGEXPR = 41;
graphLexer.NODE = 42;
graphLexer.NOT = 43;
graphLexer.OF = 44;
graphLexer.ON = 45;
graphLexer.ONDIGRETURN = 46;
graphLexer.ONEXIT = 47;
graphLexer.OUTPUT = 48;
graphLexer.PREPROCESSOR = 49;
graphLexer.PRIORITY = 50;
graphLexer.RETURN = 51;
graphLexer.SAVE = 52;
graphLexer.SET = 53;
graphLexer.SHARED = 54;
graphLexer.START = 55;
graphLexer.STATIC = 56;
graphLexer.SYNC = 57;
graphLexer.SYSTEM = 58;
graphLexer.TIMEOUT = 59;
graphLexer.TRANSITIONS = 60;
graphLexer.TAGS = 61;
graphLexer.TRY = 62;
graphLexer.TYPE = 63;
graphLexer.VAR = 64;
graphLexer.WAIT = 65;
graphLexer.WHEN = 66;
graphLexer.FILL = 67;
graphLexer.BuiltinMark = 68;
graphLexer.ContextMark = 69;
graphLexer.DecimalLiteral = 70;
graphLexer.DecimalIntegerLiteral = 71;
graphLexer.BooleanLiteral = 72;
graphLexer.Empty = 73;
graphLexer.Number = 74;
graphLexer.Boolean = 75;
graphLexer.String = 76;
graphLexer.Unknown = 77;
graphLexer.NULL = 78;
graphLexer.RBRACKET = 79;
graphLexer.LBRACKET = 80;
graphLexer.RANGLE = 81;
graphLexer.LANGLE = 82;
graphLexer.RPAREN = 83;
graphLexer.LPAREN = 84;
graphLexer.RCURL = 85;
graphLexer.LCURL = 86;
graphLexer.QUOTE = 87;
graphLexer.BACKTRICK = 88;
graphLexer.COLON = 89;
graphLexer.SEMICOLON = 90;
graphLexer.COMMA = 91;
graphLexer.QMARK = 92;
graphLexer.PERIOD = 93;
graphLexer.EQUALSIGN = 94;
graphLexer.AddOp = 95;
graphLexer.RemoveOp = 96;
graphLexer.EqualOp = 97;
graphLexer.NotEqualOp = 98;
graphLexer.GreaterEqualOp = 99;
graphLexer.LessEqualOp = 100;
graphLexer.OrOp = 101;
graphLexer.TypeOr = 102;
graphLexer.AndOp = 103;
graphLexer.NotOperator = 104;
graphLexer.ID = 105;
graphLexer.LineComment = 106;
graphLexer.DocsComment = 107;
graphLexer.BlockComment = 108;
graphLexer.Whitespace = 109;



